import { useState, useEffect, useCallback } from 'react';
import { getAllBlogs, getBlogById } from '../services/blog';

export const useBlog = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedBlog, setSelectedBlog] = useState(null);

    // Load all blogs
    useEffect(() => {
        loadBlogs();
    }, []);

    const loadBlogs = async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await getAllBlogs();
            setBlogs(data);
        } catch (err) {
            console.error('Error loading blogs:', err);
            setError('Failed to load blog posts. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    const loadBlogById = async (blogId) => {
        try {
            const blog = await getBlogById(blogId);
            setSelectedBlog(blog);
            return blog;
        } catch (err) {
            console.error('Error loading blog:', err);
            return null;
        }
    };

    const clearSelectedBlog = () => {
        setSelectedBlog(null);
    };

    return {
        blogs,
        loading,
        error,
        selectedBlog,
        loadBlogById,
        clearSelectedBlog,
        refreshBlogs: loadBlogs
    };
};